import { Button, Modal } from 'react-bootstrap';
import { ListingsInventoryMovements } from '../../utilities/listings.interfaces';
import { SALESFORCE_URLS_BY_ENVIRONMENT } from '../../../common/common.entities';
import { DateTime } from 'luxon';

interface ListingsInventoryMovementsModalProps {
  movements: ListingsInventoryMovements[]
  modalVisible: boolean
  closeModal: any
  title: string
  environment: string
}
export default function ListingsInventoryMovementsModal(props: ListingsInventoryMovementsModalProps){
  if(!props.movements) return <></>
  
  return <Modal show={props.modalVisible} animation={false} onHide={props.closeModal} className='modal-xl'>
    <Modal.Header 
      closeButton
      style={{ 
        position: 'sticky', 
        top: -1, 
        zIndex: 1050, 
        backgroundColor: 'white', 
        borderBottom: '1px solid #ddd'
      }}
    >
      <Modal.Title>
        <span className='beacon-header'>{props.title}</span>
      </Modal.Title>
    </Modal.Header>
      
    <Modal.Body>
      <div style={{fontSize: 'larger'}}>      
        <table className='flexport-table'>
          <thead>
            <tr className='sticky-row'>
              <th>
                <span className='beacon-header'>MOVEMENT</span>
              </th>
              <th>
                <span className='beacon-header'>RELATED ITEM</span>
              </th>
              <th>
                <span className='beacon-header'>QUANTITY</span>
              </th>
              <th>
                <span className='beacon-header'>STATUS</span>
              </th>
              <th>
                <span className='beacon-header'>CREATED ON</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {props.movements.map((i, index) => (
              <tr>
                <td>
                  <a title='Opens the Inventory Movement in Mission Control.' href={`${SALESFORCE_URLS_BY_ENVIRONMENT[props.environment]}/${i.Id}`}  className='beacon-link' target="_blank" rel="noopener noreferrer">{i.Name}</a>
                </td>
                <td>
                  <a title={`Opens the Related ${i.Movement_Type__c} in Mission Control.`} href={`${SALESFORCE_URLS_BY_ENVIRONMENT[props.environment]}/${i.Related_Record_ID__c}`}  className='beacon-link' target="_blank" rel="noopener noreferrer">{i.Movement_Type__c}</a>
                </td>
                <td>
                  {i.Quantity__c}
                </td>
                <td>
                  {i.Inventory_Transit_Status__c ?? ''}
                </td>
                <td>
                  {DateTime.fromISO(i.CreatedDate).toFormat('MM/dd/yy t')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant='secondary' onClick={props.closeModal}>CLOSE</Button>
    </Modal.Footer>
  </Modal>
}